import { z } from 'zod';

export const orderConditionDefinitionsSchema = z.object({
  orderCollectionId: z.string().nullable(),
  saleTypeId: z.string().nullable(),
  branchId: z.string().nullable(),
  freightType: z.string().nullable(),
  shippingCompanyId: z.string().nullable(),
  brandFreightTypeId: z.string().nullable(),
  orderOperationCode: z.string().nullable(),
  orderChargeTypeCode: z.string().nullable(),
  orderBatchItemCode: z.string().nullable(),
  orderClassificationTypeCode: z.string().nullable(),
  orderClassificationCode: z.string().nullable(),
  emitInvoice: z.boolean(),
});

export type OrderConditionDefinitionsFormValues = z.infer<typeof orderConditionDefinitionsSchema>;
